import { useEffect, useState } from "react";
import { useStateGetter } from "./statehooks/UseStateGettersHook";
import {
  onDeactivate,
  onGetOrgeModules,
  onGetRedModules,
  onInstallModule,
  onRemove,
} from "../services/modules";
import { toast } from "react-toastify";
import { useStateSetter } from "./statehooks/UseStateSettersHook";
import { useParams } from "react-router-dom";

const useModulesHook = () => {
  const [allOrgModules, setallOrgModules] = useState<any[]>([]);
  const [allRedModues, setallRedModues] = useState([]);
  const { config } = useStateGetter();
  const [notinstalled, setnotinstalled] = useState([]);
  const { setLoading } = useStateSetter();

  const{orgid}=useParams()
  const getRedModules = async () => {
    try {
      setLoading(true);
      var response = await onGetRedModules(config);

      setallRedModues(response.data);
      setLoading(false);
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  const Deactivate= async (id:any)=>{

    setLoading(true);
    const postdata = {
      organizationID:orgid,
      moduleID: id
  };
    try {
      var response = await onDeactivate(postdata, config);
      toast.success("Module Deactivated");
      setLoading(false);
      refresh();
    } catch (e: any) {
      toast.error(e);
      setLoading(false);

      console.log(e);
    }
    setLoading(false);
  }
  const Remove= async (id:any)=>{

    setLoading(true);
    const postdata = {
      organizationID:orgid,
      moduleID: id
  };
    try {
      var response = await onRemove(postdata, config);
      toast.success("Module Removed");
      setLoading(false);
      refresh();
    } catch (e: any) {
      toast.error(e);
      setLoading(false);

      console.log(e);
    }
    setLoading(false);
  }
  const getOrgModules = async () => {
    try {
      setLoading(true);
      var response = await onGetOrgeModules(orgid, config);

      setallOrgModules  (() => {
        var arr: any[] = [];
        response.data.modules.map((item: any) => arr.push(item.module));

        return arr;
      });
      setLoading(false);
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  const InstallModule = async (Moduleid: any) => {
    setLoading(true);
    const postdata = {
      organizationID: orgid,
      moduleID: Moduleid,
    };
    try {
      var response = await onInstallModule(postdata, config);
      toast.success(response.message);
      setLoading(false);
      refresh();
    } catch (e: any) {
      toast.error(e);
      setLoading(false);

      console.log(e);
    }
    setLoading(false);
  };

  const isintalled = (id: any) => {
    var installed = allOrgModules.some((i: any) => id == i.id);
    return installed;
  };

  useEffect(() => {
    allRedModues.map(() => {
      setnotinstalled((b: any) =>
        allRedModues.filter((item: any) => !isintalled(item.id))
      );
    });
  }, [allRedModues]);
  const refresh =async  () => {
  await   getRedModules();
  await   getOrgModules();
  };

  useEffect(() => {
    getRedModules();

    getOrgModules();
  }, []);
  return {
    InstallModule,
    allOrgModules,
    Remove,
    Deactivate,
    notinstalled,
    isintalled,
    allRedModues,
  };
};

export { useModulesHook };
